var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "version-detail" }, [
    _c("div", {
      staticClass: "pro-dt-close",
      attrs: { id: "close_order" },
      on: { click: _vm.closeDetail }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "block" }, [
      _c("div", { staticClass: "block-left" }, [
        _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_ACCOUNT")) + ":")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block-right" }, [
        _c("span", { domProps: { innerHTML: _vm._s(_vm.PageInfo.user_name) } })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "block" }, [
      _c("div", { staticClass: "block-left" }, [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.getConstants("PRICING_NEW_DETAIL_CURRENT_VERSION")) +
            ":\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block-right" }, [
        _c("span", [_vm._v(_vm._s(_vm.currentVersionText))]),
        _vm._v(" "),
        !_vm.isUserFree
          ? _c("span", [
              _c("span", [
                _vm._v(
                  "（\n\t\t\t\t\t" +
                    _vm._s(
                      _vm.getConstants("PRICING_NEW_DETAIL_EXPRIED_TIME")
                    ) +
                    "  "
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { style: _vm.isUserExpired ? "color: #ff5252;" : "" },
                [_vm._v(_vm._s(_vm.expiresTime))]
              ),
              _vm._v(")\n\t\t\t")
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "block eagle" }, [
      _c("div", { staticClass: "block-left" }, [
        _vm._v(_vm._s(_vm.paidModal.plan) + ":")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block-right" }, [
        _c("div", { staticClass: "select-eagle" }, [
          _c("div", { staticClass: "select-eagle-title" }, [
            _vm._v(_vm._s(_vm.paidModal.name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "select-eagle-detail" }, [
            _c("p", [
              _vm._v(
                "\n\t\t\t\t\t\t" +
                  _vm._s(_vm.versionText.planVersion) +
                  "\n\t\t\t\t\t\t"
              ),
              _c("span", { staticStyle: { "margin-left": "6px" } }, [
                _vm._v(_vm._s(_vm.versionText.planOrigin))
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n\t\t\t\t\t\t" +
                  _vm._s(_vm.paidModal.content) +
                  "\n\t\t\t\t\t\t"
              ),
              _c("span", { staticStyle: { "margin-left": "6px" } }, [
                _vm._v(_vm._s(_vm.paidModal.price))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "select-eagle-price" }, [
            _c("p", { staticClass: "price-time" }, [
              _vm._v(
                "\n\t\t\t\t\t\t" +
                  _vm._s(
                    _vm.getConstants("PRICING_NEW_EAGLE_SELECT_ORIGIN_SPECIAL")
                  ) +
                  "\n\t\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "price-money" }, [
              _vm._v("\n\t\t\t\t\t\t¥\n\t\t\t\t\t\t"),
              _c("span", [_vm._v(_vm._s(_vm.price.toFixed(2)))])
            ])
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "psprite psprite-selected" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "select-tip" }, [
          _vm._v(_vm._s(_vm.paidModal.tip))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "block" }, [
      _c("div", { staticClass: "block-left" }, [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.getConstants("PRICING_NEW_DETAIL_YEAR_RIGHT")) +
            "：\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block-right privilige" }, [
        _c("p", [_vm._v(_vm._s(_vm.saveText))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.priviligeText))]),
        _vm._v(" "),
        _vm.isUserExpired
          ? _c("p", { staticClass: "add-fee" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_DETAIL_ADDED_FEE")))
              ]),
              _vm._v(" "),
              _c("a", {
                staticClass: "cube",
                attrs: { href: "http://www.jianguoyun.com/s/help/?p=1366" }
              })
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "block" }, [
      _c("div", { staticClass: "block-left" }, [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.getConstants("PRICING_NEW_DETAIL_TOTAL_STORAGE")) +
            ":\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block-right" }, [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.planData.storage) +
            _vm._s(
              _vm.PageInfo.storageQuota &&
                " (" +
                  _vm.getConstants("PRICING_NEW_DETAIL_CURRENT_STORAGE") +
                  _vm.getConstants("COLON") +
                  _vm.PageInfo.storageQuota +
                  ")"
            ) +
            "\n\t\t"
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "block" }, [
      _c("div", { staticClass: "block-left" }, [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.getConstants("PRICING_NEW_DETAIL_EXPRIED")) +
            ":\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block-right charge" }, [
        _c("span", { staticClass: "fl-l" }, [
          _vm._v(_vm._s(_vm.expiresTimeAfterPay))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pay-box clearfix" }, [
      _vm.isPaidInvalid
        ? _c("div", { staticClass: "not-allowed pay-box-button" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_DETAIL_NOT_ALLOW")))
            ])
          ])
        : _c(
            "div",
            {
              staticClass: "pay-box-button",
              attrs: { id: "pay_ali" },
              on: { click: _vm.payNow }
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_DETAIL_PAY")))
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("¥ " + _vm._s(_vm.price.toFixed(2)))])
            ]
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }